import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9545_204192)">
      <path
        clipRule="evenodd"
        d="M14.1992 7L9.19922 7C8.00544 7 6.93255 7.52367 6.19922 8.35383C5.38204 9.27891 4.97459 10.5 4.97459 12C4.97459 13.5 5.38204 14.7211 6.19922 15.6462C6.93255 16.4763 8.00544 17 9.19922 17L14.1992 17L14.1992 7ZM3.28218 14C3.75825 16.8377 6.22622 19 9.19922 19L14.1992 19C15.3038 19 16.1992 18.1046 16.1992 17L16.1992 16L23.1992 16C23.7515 16 24.1992 15.5523 24.1992 15C24.1992 14.4477 23.7515 14 23.1992 14L16.1992 14L16.1992 10L23.1992 10C23.7515 10 24.1992 9.55228 24.1992 9C24.1992 8.44772 23.7515 8 23.1992 8L16.1992 8L16.1992 7C16.1992 5.89543 15.3038 5 14.1992 5L9.19922 5C6.22622 5 3.75825 7.16228 3.28218 10L2.19922 10C1.09465 10 0.199218 10.8954 0.199218 12C0.199218 13.1046 1.09465 14 2.19922 14L3.28218 14Z"
        fill="#21201F"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_9545_204192">
        <rect fill="white" height="24" transform="translate(0.199219)" width="24" />
      </clipPath>
    </defs>
  </svg>,
  'Integration',
)
